import React, {Component} from 'react';
import {AgGridReact} from 'ag-grid-react';

import * as firebase from 'firebase';

import 'ag-grid/dist/ag-grid.js';
import 'ag-grid/dist/ag-grid.min.js';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';

//import './user.scss';

class StudentStats extends Component {
    constructor(props) {
        super(props);
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        console.log("dealermode",props.location.state.dealerMode);
        this.state = {
            students: [],
            value: "",
            user: this.props.user,
            vwap: '-',
            displayStats: {},
            studentsData: [],
            lastPrice: '-',
            isSessionAdmin: true,
            gridOptions: {
                defaultColDef: {
                    editable: false
                },
                api: {},
                columnApi: {},
                columnDefs: [
                    {
                        headerName: "#",
                        field: "id",
                        width: 75,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "User",
                        field: "user",
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "Shares",
                        field: "shares",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: (props.location.state.dealerMode ? "Market Share" : "Mission"),
                        field: "mission",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "P/L",
                        field: "pl",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "BuyVWAP",
                        field: "avgbuy",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "SellVWAP",
                        field: "avgsell",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    },
                    {
                        headerName: "MarketVWAP",
                        field: "marketvwap",
                        width: 150,
                        filter: "agTextColumnFilter",
                        floatingFilterComponentParams: {suppressFilterButton: true},
                        suppressMenu: true
                    }
                ],
                pagination: true,
                floatingFilter: true,
                rowData: '',
                enableSorting: true,
                onGridReady: this.onGridReady.bind(this),
                enableFilter: true
            }
        }

        this.listeners = [];
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 600);
    }

    registerStats(key){
      console.log("register stats", key);
      if (!this.props.location.state.dealerMode){
        console.log("not Dealer");
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
        let mRef = userStatRef.child("Mission");
        mRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].mission = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(mRef);
        let sRef = userStatRef.child("Shares");
        sRef.on("value", ss=>{
          let data = ss.val();
          console.log("test",data);
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            console.log(displayStats);
            displayStats[key].shares = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        let cashRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("Cash");
        cashRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].cash = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(cashRef);
        let bvwapRef = userStatRef.child("BuyVWAP");
        bvwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].bvwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(bvwapRef);
        let svwapRef = userStatRef.child("SellVWAP");
        svwapRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].svwap = data;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(svwapRef);
      } else {
        let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Dealers").child(key);
        userStatRef.on("value", ss=>{
          let data = ss.val();
          if (!!data){
            let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
            displayStats[key].shares = data.position;
            displayStats[key].mission = data.marketShare;
            displayStats[key].cash = data.cash;
            displayStats[key].bvwap = data.avgBuy;
            displayStats[key].svwap = data.avgSell;
            this.setState({displayStats});
            this.createRows();
          }
        });
        this.listeners.push(userStatRef);
      }
    }

    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })
        console.log("Users Pending Loading");
        var studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        studentRef.on('value', snap =>{
          let rawData = snap.val();
          console.log("data of student ",rawData);
          let studentInfo;
          let students = [];

          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  console.log(key);
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-", bvwap: "-", svwap: "-", cash: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }

          this.setState({
              studentsData: students,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
        })
        this.listeners.push(studentRef);
    }

    componentDidMount() {
      var vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Assets").child("INTC").child("VWAP");
      var priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData").child("SessionData").child("lastPrice");
      if (this.props.location.state.dealerMode){
        vwapRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("VWAP");
        priceRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DealerMarket").child("lastPrice");
      }
      vwapRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"vwap": data});
        }
      });
      this.listeners.push(vwapRef);

      priceRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          this.setState({"lastPrice": data});
        }
      });
      this.listeners.push(priceRef);
    }

    formatMoney(value){
      if (!value){
        return "-";
      } else {
        return value.toFixed(4);
      }
    }

    componentWillUnmount() {
        this.listeners.map(theRef=>{
          theRef.off();
        });
    }

    filterQuick(event) {
        console.log(this.state.gridOptions.rowData);
        this.state.gridOptions.api.setQuickFilter(event.target.value);

    }

    createRows() {
        let rows = [];
        for (let i = 0; i < this.state.studentsData.length; i++) {
          let student = this.state.studentsData[i];
          let stats = this.state.displayStats[student.uid];
          console.log(this.state.lastPrice, stats);
          console.log(parseFloat(stats.cash) + parseFloat(stats.shares)*parseFloat(this.state.lastPrice));

            rows.push({
                id: i + 1,
                user: student.displayName,
                shares: stats.shares,
                mission: stats.mission,
                pl: this.formatMoney(parseFloat(stats.cash) + parseFloat(stats.shares)*parseFloat(this.state.lastPrice)),
                avgbuy: stats.bvwap,
                avgsell: stats.svwap,
                marketvwap: this.formatMoney(parseFloat(this.state.vwap))
            });
        }
        this.state.gridOptions.rowData = rows;
        this.setState(this.state);
    }

    onGridReady(params) {
        this.state.gridOptions.api = params.api;
        this.state.gridOptions.columnApi = params.columnApi;
        this.state.gridOptions.api.selectAll();
        this.setState(this.state)
    }

    render() {
        return (
            <div>
                <button onClick={() => this.state.gridOptions.api.exportDataAsCsv()}>export</button>
                <div className="leader-board ag-theme-material">
                    <AgGridReact
                        columnDefs={this.state.gridOptions.columnDefs}
                        rowData={this.state.gridOptions.rowData}
                        gridOptions={this.state.gridOptions}
                    />
                </div>
            </div>
        );
    }
}

export default StudentStats



// WEBPACK FOOTER //
// ./src/components/Dashboard/StudentStats.js